import Customer from '@/classes/Customer';

import IToken from '@/interfaces/Token';

import { ICustomerState } from './state';

import { tokenDecoder } from '@/helpers/token';
import { isValid } from '@/helpers/values';
import { tokenExpirationDate } from '@/helpers/token';

import { ICustomer } from '@/interfaces/Customer';
import { IAddress } from '@/interfaces/Address';

export default {
  requestSignin(state: ICustomerState) {
    state.isLoading = true;
  },
  updateToken(state: ICustomerState, token: string) {
    state.token.updateValue(token)
      .updateExpires(tokenExpirationDate(token))
      .setCookie();
  },
  removeToken(state: ICustomerState) {
    state.token.updateValue('').deleteCookie();
  },
  successSignin(state: ICustomerState, token: string) {
    const tokenData: IToken = tokenDecoder(token);

    state.isLoading = false;

    state.token.updateValue(token)
      .updateExpires(tokenExpirationDate(token))
      .setCookie();

    state.customer = new Customer({
      acta_user_id: isValid(tokenData) && tokenData.sub ? tokenData.sub : '',
      name: isValid(tokenData) && tokenData.userName ? tokenData.userName : '',
      email: isValid(tokenData) && tokenData.email ? tokenData.email : '',
    });

    return state.customer;
  },
  errorSignin(state: ICustomerState, response: any) {
    state.isLoading = false;
    state.token.deleteCookie();
  },
  requestSignup(state: ICustomerState) {
    state.isLoading = true;
  },
  successSignup(state: ICustomerState, token: string) {
    state.isLoading = false;
    state.token.updateValue(token).setCookie();
  },
  errorSignup(state: ICustomerState, response: any) {
    state.isLoading = false;
    state.token.deleteCookie();
  },
  requestLogout(state: ICustomerState) {
    state.isLoading = true;
  },
  successLogout(state: ICustomerState, response: any) {
    state.isLoading = false;
    state.token.deleteCookie();

    state.customer = new Customer();
  },
  errorLogout(state: ICustomerState, response: any) {
    state.isLoading = false;
    state.token.deleteCookie();
  },
  requestDetails(state: ICustomerState) {
    state.isLoading = true;
  },
  successDetails(state: ICustomerState, customer: ICustomer) {
    state.isLoading = false;
    state.customer = new Customer(customer);
  },
  errorDetails(state: ICustomerState, response: any) {
    state.isLoading = false;
  },
  requestRewardsSummary(state: ICustomerState) {
    state.isLoading = true;
  },
  successRewardsSummary(state: ICustomerState, summary: any) {
    state.isLoading = false;
    state.rewardsSummary = summary;
  },
  errorRewardsSummary(state: ICustomerState, response: any) {
    state.isLoading = false;
  },
  setRegisterIsIncomplete(state: ICustomerState, isIncomplete: boolean) {
    state.registerIsIncomplete = isIncomplete;
  },
  setLoading(state: ICustomerState, isLoading: boolean) {
    state.isLoading = isLoading;
  },
  setDeliveryAddress(state: ICustomerState, address: IAddress) {
    state.customer.delivery_address = address;
  },
  setAddresses(state: ICustomerState, addresses: IAddress[] = []) {
    state.customer.addresses = addresses;

    const deliveryAddress = addresses.find(address => !!address.is_default) || addresses[0];
    if (deliveryAddress) {
      deliveryAddress.zipCodeData = true;
      state.customer.delivery_address = deliveryAddress;
    }
  },
};
